import { useState } from "react";
import { submitSupportCase } from "../../utils/supportNavUtils";
import useAppStateStore from "../../../../shared/store/AppStateStore";
import ModalWrapper from "../../../../shared/components/ModalWrapper";
import useSupportStore from "../../store/supportStore";
import Button from "../../../../shared/components/Button";
import { FiChevronLeft } from "react-icons/fi";
import { useNavigate } from "fusion-plugin-react-router";

const CancellationDisclaimer = () => {
  const STATE = useAppStateStore();
  const SUPPORT_STORE = useSupportStore();
  const isCancellation =
    SUPPORT_STORE?.spCancellation?.cancellationReason?.value ===
    "cancellation_quote";

  const [currentStep, setCurrentStep] = useState(1);
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleCheckboxChange = (e) => {
    setTermsAccepted(e.target.checked);
    if (e.target.checked) {
      setError("");
    }
  };
  const onClose = () => {
    STATE.setIsCancellationModalOpen(false);
  };

  const onClick = () => {
    if (currentStep === 1) {
      setCurrentStep(2);
      setTermsAccepted(false);
      setError("");
      return;
    }

    if (!termsAccepted) {
      setError(
        "Please confirm that you have read and understood the disclaimer.",
      );
      return;
    }
    submitSupportCase(navigate);
    onClose();
  };

  const getStepContent = () => {
    if (currentStep === 1) {
      return isCancellation ? (
        <div className="tw-flex tw-flex-col tw-gap-3 tw-text-base tw-leading-[1.45] tw-text-dis-text-2">
          <p className="tw-m-0">
            You'll be sent a cancellation quote showing any charges. To go
            ahead, you'll need to confirm that you're happy with the quote.
          </p>
          <p className="tw-m-0">
            If you don't need a quote and just want to cancel the policy
            straight away, please select Cancel Policy.
          </p>
          <p className="tw-mt-3">
            <strong>Important Payment Information</strong>
          </p>
          <p className="tw-m-0">
            If you've paid by Direct Debit and are still within the current
            payment cycle, your cancellation quote will be based on the full
            payment clearing first.
          </p>
          <p className="tw-m-0">
            If there is an outstanding or fault claim on your policy during the
            insured period, no refund will be due from the insurer.
          </p>
        </div>
      ) : (
        <div className="tw-flex tw-flex-col tw-gap-3 tw-text-base tw-leading-[1.45] tw-text-dis-text-2">
          <p className="tw-m-0">
            Your cancellation will be processed from the date and time provided
            above. You will receive your cancellation confirmation with a
            breakdown of charges by close of business at 5PM.
          </p>
          <p className="tw-m-0">
            If you want a cancellation quote and do not wish for the policy to
            be cancelled, please select Cancellation Quote.
          </p>
          <p className="tw-m-0">
            If you have paid via direct debit and are currently in the payment
            cycle, your cancellation figures will be based on this payment
            clearing.
          </p>
          <p className="tw-m-0">
            If you have an outstanding or fault claim within your policy period,
            there will be no refund due from the insurer.
          </p>
        </div>
      );
    } else {
      return (
        <div className="tw-flex tw-flex-col tw-gap-3 tw-text-base tw-leading-[1.45] tw-text-dis-text-2">
          <p className="tw-m-0">
            <strong>Please note:</strong> We process changes Monday to Friday,
            9am to 4pm (business hours).
          </p>
          <p className="tw-m-0">
            If you request a change outside these hours, it will be processed
            when we reopen — and cover will start from that time. We can't
            backdate cover.
          </p>
          <p className="tw-m-0">
            <strong>Example:</strong> If you request a cancellation at 5pm on
            Wednesday to take effect at 10pm the same day, we'll process it at
            9am on Thursday, and cover will end from that point — not the time
            you requested.
          </p>
        </div>
      );
    }
  };

  return (
    <ModalWrapper
      heading="Cancellation Disclaimer"
      buttonText={currentStep === 1 ? "Next" : "Proceed"}
      showClose={true}
      onClose={onClose}
      onButtonClick={onClick}
      showCheckbox={currentStep === 2}
      checkboxLabel="I have read and understood the disclaimer."
      checkboxChecked={termsAccepted}
      checkboxError={error}
      onCheckboxChange={handleCheckboxChange}
    >
      {currentStep === 2 && (
        <Button
          type="button"
          variant="soft"
          size="small"
          className="tw-self-start tw-gap-3 tw-pl-1.5 tw-pr-5"
          leadingIcon={
            <span className="tw-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-rounded-full tw-bg-white">
              <FiChevronLeft
                className="tw-h-5 tw-w-5"
                strokeWidth={2.5}
                aria-hidden="true"
              />
            </span>
          }
          onClick={() => setCurrentStep(1)}
        >
          Back
        </Button>
      )}
      {getStepContent()}
    </ModalWrapper>
  );
};

export default CancellationDisclaimer;
